export default __webpack_public_path__ + "static/media/arrow-right-icon.312b81a0.svg";